{
  "header": {
    "filters": {
      "brand": "Marque",
      "collection": "Saison / Collection",
      "label": "Filtres",
      "productType": "Catégorie"
    },
    "search": {
      "label": "Recherche",
      "placeholder": "nom, label ou reference du produit"
    }
  },
  "productCard": {
    "productType": "Catégorie :",
    "reference": "Reférence :"
  }
}
